'use strict';
/**
 * <settings-panel> - menu-only sub-screen (Tank Color / Sound / Music /
 * Light Theme). Light DOM, no shadow root: client.js keeps looking up its
 * children by plain id (#settings-back-btn, #sfx-toggle, ...), same as when
 * this markup lived directly in index.html - only the wrapper tag changed
 * from <div id="settings-panel"> to <settings-panel id="settings-panel">.
 *
 * Deliberately a classic (non-module) script, loaded before client.js's own
 * <script> tag in index.html: customElements.define() upgrades - and
 * therefore populates the innerHTML of - every matching element already
 * parsed into the document synchronously, the moment this script runs. That
 * has to finish before client.js's top-level `getElementById(...)` calls for
 * this panel's children run, or they'd find nothing yet.
 */
class SettingsPanel extends HTMLElement {
  connectedCallback() {
    if (this.childElementCount) return;
    this.innerHTML = `
      <div class="settings-header">
        <button id="settings-back-btn" class="icon-btn-inline" aria-label="Back to menu" title="Back to menu">
          <svg class="icon"><use href="#icon-back"/></svg>
        </button>
        <h2>Settings</h2>
      </div>

      <div class="settings-list">
        <div class="settings-row">
          <div class="settings-row-label"><svg class="icon"><use href="#icon-palette"/></svg>Tank Color</div>
          <button id="open-studio-row-btn" class="icon-btn-inline" aria-label="Open Tank Design Studio" title="Tank Design Studio">
            <svg class="icon"><use href="#icon-palette"/></svg>
          </button>
        </div>

        <div class="settings-row">
          <div class="settings-row-label"><svg class="icon"><use href="#icon-sound-on"/></svg>Sound Effects</div>
          <button id="sfx-toggle" class="toggle-switch" role="switch" aria-checked="true" aria-label="Toggle sound effects"><span class="toggle-knob"></span></button>
        </div>

        <div class="settings-row">
          <div class="settings-row-label"><svg class="icon"><use href="#icon-music-on"/></svg>Music</div>
          <button id="music-toggle" class="toggle-switch" role="switch" aria-checked="true" aria-label="Toggle music"><span class="toggle-knob"></span></button>
        </div>

        <div class="settings-row">
          <div class="settings-row-label"><svg class="icon"><use href="#icon-sun"/></svg>Light Theme</div>
          <button id="theme-toggle-row" class="toggle-switch" role="switch" aria-checked="false" aria-label="Toggle light theme"><span class="toggle-knob"></span></button>
        </div>
      </div>
    `;
  }
}

customElements.define('settings-panel', SettingsPanel);
